<!--
 * @Author: '李志远' '506642370@qq.com'
 * @Date: 2021-05-24 11:53:09
 * @LastEditors: '李志远' '506642370@qq.com'
 * @LastEditTime: 2022-08-31 21:39:40
 * @FilePath: \buyer_vue\src\views\gold-shop\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
/*
创建者 魏强(2018.1.30)
金牌网店
*/
<template>
   <div id="new-shop-page">
      <!-- 金牌网店banner -->
      <banner v-if="personalUpAdv.length>0" :data="personalUpAdv"></banner>
      <div class="wrapper">
        <!-- 精品速递 -->
        <boutique v-if="jpsdGoodsAdvLeftList"
          :jpsdGoodsAdvRightList="jpsdGoodsAdvRightList"
          :jpsdGoodsAdvLeftList="jpsdGoodsAdvLeftList" >
        </boutique>

        <!-- 人气热推 -->
        <reference :hotPersonalStoreList="hotPersonalStoreList" :hotPersonalStoreGoodList="hotPersonalStoreGoodList" >
        </reference>

        <store-list v-if="storeList.length>0" :data="storeList"></store-list>

      </div>
   </div>
</template>
<script>
import {personalGolden} from 'api/home';
import {parseAdvList} from 'utils/tool';
import banner from './banner';
import boutique from './module-boutique';
import reference from './module-reference';
import storeList from './good-shop';
  export default {
    components:{
      banner,boutique,reference,storeList
    },
    data(){
      return {
        personalUpAdv:[],
        jpsdGoodsAdvRightList:[],
        jpsdGoodsAdvLeftList:[],
        hotPersonalStoreList:[],
        hotPersonalStoreGoodList:[],
        storeList:[]
      }
    },
    created(){
      this.fetchData();
    },
    methods:{
      fetchData(){
        personalGolden().then(json=>{
          if(json.resCode==1){
            let data = json.data;
            this.personalUpAdv= parseAdvList( data.homeBannerAdvertisementDTO.advList);
            this.jpsdGoodsAdvRightList=parseAdvList(data.goldenShopDownAdvertisementDTO.advList);
            this.jpsdGoodsAdvLeftList=parseAdvList(data.goldenShopLeftAdvertisementDTO.advList);
            let hotPersonalStore=data.personStoreGoodsDTO;
            this.hotPersonalStoreGoodList=hotPersonalStore.storeTagRelGoodsDTOList;
            this.hotPersonalStoreList=hotPersonalStore.storeDetailDTOList,
            this.storeList=data.storeDetailDTOList;
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?6dccb5ca